import React, { useEffect, useMemo } from 'react'
import { Box } from '@mui/material'
import { useForm } from 'react-hook-form'
import PageTitle from '../../components/PageTitle'
import { FormProvider } from '../../common/hook-form'
import { MerchantFilterCached } from '../../common/ProshipFormComponents'
import ShopifyEddLocationPanel from './ShopifyEddLocationPanel'
import { apiFor } from './shopifyEddLocationApi'

/** Last merchant opened on this page, so coming back does not start from an empty picker (same idea as the PTL ODA page). */
const LAST_MERCHANT = 'shopifyEdd.lastMerchantOid'
const readLast = () => { try { return window.localStorage.getItem(LAST_MERCHANT) || '' } catch (e) { return '' } }
const writeLast = (v) => { try { if (v) window.localStorage.setItem(LAST_MERCHANT, v) } catch (e) { /* storage blocked: nothing to remember */ } }

/**
 * Merchant Setup → Shopify EDD Pickup Mapping (admin panel). The merchant picker sits in the panel's toolbar; the
 * rest is the same config the merchant edits under Settings on their own panel.
 */
export default function ShopifyEddLocation() {
  const methods = useForm({ defaultValues: { merchant: readLast() } })
  const merchantOid = methods.watch('merchant')
  const api = useMemo(() => (merchantOid ? apiFor(merchantOid) : null), [merchantOid])

  useEffect(() => { writeLast(merchantOid) }, [merchantOid])

  // The shared select only comes in the medium size; trim it to the 40px height of the small controls beside it.
  const picker = (
    <Box sx={{ width: 300, bgcolor: 'background.paper', borderRadius: 1, '& .MuiOutlinedInput-root': { minHeight: 40, py: 0 }, '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { top: -7 } }}>
      <FormProvider methods={methods} onSubmit={(e) => e.preventDefault()}>
        <MerchantFilterCached />
      </FormProvider>
    </Box>
  )

  return (
    <>
      <PageTitle>Setup Pickup Drop Mapping</PageTitle>
      <ShopifyEddLocationPanel key={merchantOid || 'none'} api={api} header={picker} />
    </>
  )
}
